import { createAsyncThunk } from "@reduxjs/toolkit";
import referralApi from 'api/referralApi';
import { formatQueryParams } from "helpers/format";
import 'react-toastify/dist/ReactToastify.css';

export const getReferralRewards = createAsyncThunk("Rewards", async (params: any = {}) => {
  try {
    const response = await referralApi.rewards(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const updateReward = async (id: string | number, data: any = {}) => {
  try {
    const response = await referralApi.putReward(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
